import lessRequire from '../../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import renderViewsState from '../../shared/render-views-state';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { baseUrl } from '../../../config/route-entry-point';

import Form from './components/form';
import Table from './components/table';

lessRequire('modules/tickets/item/main.less');

const Main = renderViewsState(props => {
	const { closeTicket, formData, intl } = props;

	const isClosed = props.data.status === 'closed' || !!props.data.closed_at;
	const isVoted = props.data.rating != 1;
	const activeClassUpvote = props.data.rating == 2 ? 'active' : '';
	const activeClassDownvote = props.data.rating == 0 ? 'active' : '';

	return (
		<div className="ticket-item container">
			<div className="content-container ticket-item__answer clearfix">
				<div className="content-container__title">
					<h2 className="font-proxima-nova-bold">{ props.data.title }</h2>
					<div className="ticket-item__answer-control">
						<Link className="go-back" to={baseUrl('tickets/')}>{intl('Назад к тикетам')}</Link>
						{ isClosed && <span className="status status-inactive">{intl('Тема закрыта')}</span> }

					</div>
				</div>
				<Form {...props}
					initialValues={formData.initialValues}
					enableReinitialize={true}
					destroyOnUnmount={false}
					forceUnregisterOnUnmount={false}
					filesToUpload={formData.filesToUpload}
					isClosed={isClosed}
					uploadError={formData.uploadError}
				/>
			</div>
			<div className="triangle" />

			<div className="content-container ticket-item__answers">

				{!isClosed && (<div className="ticketActions">
					<span className="text font-proxima-nova-regular">
						{intl('Помог ли менеджер решить Ваш вопрос?')}
					</span>
					<button className="button font-proxima-nova-regular close-ticket"
						onClick={e => closeTicket()}>
						{intl('Да, вопрос решен')}
					</button>
					<button className="button font-proxima-nova-regular newpost" onClick={e => {
						document.body.querySelector(
							'textarea'
						).focus();
						window.scrollTo(0, 0);
					}}>
						{intl('Нет, остались вопросы')}
					</button>
				</div>)
				}

				{isClosed && !isVoted
						&& (<div className="ticketActions">
							<table>
								<tr>
									<td>
										<span className="text font-proxima-nova-regular closed">
											{intl('Тикет #')}{props.data.id}{intl('закрыт. Спасибо за обращение!')}
											{intl(' ')}
											{intl('Довольны ли Вы работой службы поддержки?')}
										</span>
									</td>
									<td>
										<div className="votings">
											<button className="vote-button vote-up" onClick={e => props.threadVote(2)} />
											<button className="vote-button vote-down" onClick={e => props.threadVote(0)} />
										</div>
									</td>
								</tr>
							</table>
						</div>)
				}

				{isClosed && isVoted
						&& (<div className="ticketActions">
							<table>
								<tr>
									<td>
										<span className="text font-proxima-nova-regular closed">
											{intl('Тикет #')}{props.data.id}{intl('закрыт. Спасибо за обращение!')}
										</span>
									</td>
									<td>
										<div className="votings">
											<span className={`${activeClassUpvote} vote-button vote-up  just-voted`} disabled={true}/>
											<span className={`${activeClassDownvote} vote-button vote-down`} disabled={true}/>
										</div>
									</td>
								</tr>
							</table>
						</div>)
				}

				<Table
					thread={props.data}
					user={props.user}
					answerVote={props.answerVote}
					intl={intl}
				/>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		progressBar: selectors.getProgressBar(state),
		formData: selectors.getFormData(state),
		user: selectors.getUserInfo(state),
		error: selectors.getError(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/tickets/item/main.js